import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";

export default function VerticalBar(props: any) {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = "#b2b2b6";
    const textColorSecondary = "#b2b2b6";
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    const data = {
      labels: props.labels, //props.data.labels
      datasets: [
        {
          label: "Presupuesto Base",
          backgroundColor: documentStyle.getPropertyValue("--blue-500"),
          borderColor: documentStyle.getPropertyValue("--blue-500"),
          data: props.data1, //props.data.pptoAnterior
        },
        {
          label:
            props.context === "order"
              ? "Presupuesto a tomar"
              : "Presupuesto Solicitado",
          backgroundColor:
            props.context === "order"
              ? documentStyle.getPropertyValue("--green-900")
              : documentStyle.getPropertyValue("--pink-500"),
          borderColor:
            props.context === "order"
              ? documentStyle.getPropertyValue("--green-900")
              : documentStyle.getPropertyValue("--pink-500"),
          data: props.data2, //props.data.pptoAnterior
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  return (
    <div style={{ width: "60%", alignContent: "center" }} className="card">
      {Object.keys(chartData).length > 0 && Object.keys(chartOptions).length ? (
        <Chart type="bar" data={chartData} options={chartOptions} />
      ) : null}
    </div>
  );
}
